import React, {useCallback, useContext, useEffect, useState} from "react"
import {useLocation, useParams} from "react-router-dom"
import {RepoDescription} from "../../components/Repo/RepoDescription"
import {RepoHeader} from "../../components/Repo/RepoHeader"
import {BackendContext} from "../../context/BackendContext"
import {useCloneRepo} from "../../hooks/useCloneRepo"
import {useFetchProfile} from "../../hooks/useFetchProfile"
import {useFetchRepoDB} from "../../hooks/useFetchRepoDB"
import {useGitDir} from "../../hooks/useGitDir"
import {RepoContentRoutes} from "../../routes/RepoContentRoutes"
import {RepoTab} from "../../enum/RepoTab"
import styles from "./index.module.scss"
import {LoadingPageTransition} from "../../components/App/LoadingPageTransition"


export const Repo = () => {
  const {profileOrbitId, orbitId, publicKey, repoId} = useParams()
  const gitDir = useGitDir(orbitId, repoId)
  const {metadata} = useContext(BackendContext)
  const profileAddress = `/orbitdb/${profileOrbitId}/${publicKey}`
  const {profile, profileReplCnt} = useFetchProfile(profileAddress)
  const {repoDB, repoReplCnt, setRepoReplCnt} = useFetchRepoDB(orbitId, repoId)
  const {cloneCnt} = useCloneRepo(repoReplCnt, repoDB)
  const isCloned = cloneCnt > 0
  const [tab, setTab] = useState<RepoTab>()
  const [profileDisplayName, setProfileDisplayName] = useState<string>()
  const location = useLocation()

  const remoteHost = metadata?.isGitSupported === true ? "http://internal.degit.io:21560" : "http://localhost:21560"

  const detectTab = useCallback((
    repoId: string,
    profileOrbitId: string,
    publicKey: string,
    orbitId: string,
    pathName: string
  ) => {
    const basePath = `/repos/${profileOrbitId}/${publicKey}/${orbitId}/${repoId}`

    if (pathName.startsWith(`${basePath}/codes`)) {
      setTab(RepoTab.Codes)
    } else if (pathName.startsWith(`${basePath}/prs`)) {
      setTab(RepoTab.PR)
    } else if (pathName.startsWith(`${basePath}/issues`)) {
      setTab(RepoTab.Issues)
    } else if (pathName.startsWith(`${basePath}/settings`)) {
      setTab(RepoTab.Settings)
    }
  }, [])

  // Change layout when tab is changed
  useEffect(() => {
    if (!repoId || !publicKey || !orbitId || !profileOrbitId) {
      return
    }
    const pathName = location.pathname
    detectTab(repoId, profileOrbitId, publicKey, orbitId, pathName)
  }, [location, profileOrbitId, repoId, orbitId, publicKey, detectTab])

  useEffect(() => {
    if (!profile || !publicKey) {
      return
    }
    const displayName = profile.get("name")
    setProfileDisplayName(displayName ?? publicKey)
  }, [profile, profileReplCnt, publicKey])

  if (!profile || !repoDB) {
    return null
  }

  return (
    <div className={styles.Container}>
      <RepoHeader repoName={repoDB.get("name")} displayName={profileDisplayName} tab={tab}/>
      <div className={styles.ContentContainer}>
        {isCloned && <RepoDescription repoDB={repoDB} repoUrl={`${remoteHost}/git${gitDir}`}/>}
        <div className={styles.RouteContainer}>
          {
            isCloned
              ? <RepoContentRoutes
                cloneCnt={cloneCnt}
                repoDB={repoDB}
                repoReplCnt={repoReplCnt}
                setRepoReplCnt={setRepoReplCnt}
              />
              : <LoadingPageTransition text={"Take a cup of coffee and we will be ready soon :)"}/>
          }
        </div>
      </div>

    </div>
  )
}


